import * as apiService from './api';
import * as mockService from './mock';
import { ParcelData, LockerAssignment } from '../types';
import { Company } from '@/types/Company';
import { CompanyDepositRequest } from '@/types/CompanyDepositRequest';
import { CompanyDepositResponse } from '@/types/CompanyDepositResponse';

// Define the shape of our service
interface LockerService {
  verifyPhone: (phone: string, company: string) => Promise<boolean>;
  sendOTP: (phone: string) => Promise<void>;
  verifyOTP: (phone: string, otp: string) => Promise<boolean>;
  getParcelData: (barcode: string) => Promise<ParcelData>;
  getParcelDataByBarcode: (barcode: string) => Promise<ParcelData>;
  fetchLockerAssignment: (phone: string) => Promise<LockerAssignment>;
  assignLocker: (size: string, type: string) => Promise<LockerAssignment>;
  calculateAmount: (
    size: string,
    type: string,
    holdTime: number
  ) => Promise<number>;
  getCompanies: () => Promise<Company[]>;
  confirmPayment: (assignmentId: string) => Promise<boolean>;
  createCompanyDeposit: (
    request: CompanyDepositRequest
  ) => Promise<CompanyDepositResponse>;
  completeCollection: (assignmentId: string) => Promise<boolean>;
}

const isProduction = true;

// Use type assertion to tell TypeScript that both services implement LockerService
const service: LockerService = isProduction
  ? (apiService as LockerService)
  : (mockService as LockerService);

export const {
  verifyPhone,
  sendOTP,
  verifyOTP,
  getParcelData,
  getParcelDataByBarcode,
  assignLocker,
  calculateAmount,
  getCompanies,
  fetchLockerAssignment,
  confirmPayment,
  createCompanyDeposit,
  completeCollection,
} = service;

// Re-export types for convenience
export type { ParcelData, LockerAssignment };
